var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubMenuArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 16,
    viewBox: "0 0 8 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.24409 0.500074C1.40415 0.49953 1.56228 0.534854 1.70689 0.60345C1.8515 0.672045 1.9789 0.77217 2.07973 0.896466L7.25424 7.32443C7.41181 7.51613 7.49796 7.75658 7.49796 8.00472C7.49796 8.25287 7.41181 8.49332 7.25424 8.68502L1.8976 15.113C1.71576 15.3318 1.45445 15.4693 1.17116 15.4955C0.887876 15.5216 0.605815 15.4341 0.387033 15.2523C0.16825 15.0704 0.0306654 14.8091 0.00454664 14.5258C-0.0215721 14.2425 0.0659142 13.9605 0.24776 13.7417L5.03659 7.99937L0.408459 2.25705C0.277454 2.0998 0.194236 1.90831 0.168653 1.70524C0.143071 1.50217 0.176193 1.29602 0.264102 1.11119C0.35201 0.926353 0.491026 0.77057 0.664699 0.662269C0.838372 0.553968 1.03943 0.497684 1.24409 0.500074Z",
    fill: "#003C9D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubMenuArrow);
export default __webpack_public_path__ + "static/media/subMenuArrow.c328fc4fb5173348fc0ccb63e4a7b552.svg";
export { ForwardRef as ReactComponent };